<template>
	<div>
		<div class="display-flex flex-column width-100" v-for="item in allCalculatedDirectoryApps" :key="item.id">
			<ManageAppsFavoriteAppsListItem
				:id="item?.id"
				:icon="item?.icon"
				:name="item?.service_name"
				:tooltipText="getToolTipText(item)"
				:description="getDescription(item)"
				:cantDelete="Boolean(item.cantDeleteReason)"
			/>
		</div>
		<template v-if="userRequestedApps?.length > 0">
			<h2 class="reg mt-12 mb-4">Requested</h2>
			<div class="display-flex flex-column width-100" v-for="item in userRequestedApps" :key="item.id">
				<ManageAppsFavoriteAppsListItem
					requestMode
					:id="item?.id"
					:icon="item?.icon"
					:name="item?.service_name"
					tooltipText="Remove app request"
				/>
			</div>
		</template>
	</div>
</template>

<script>
import { getAllDirectoryApps } from '@/store/modules/apps/actions';
import ManageAppsFavoriteAppsListItem from './ManageAppsFavoriteAppsListItem';
import { mapGettersShorthand, mapActionsShorthand } from '@/store/utils/mappers';
import { allCalculatedDirectoryApps, allCalculatedDirectoryAppsIds, userRequestedApps } from '@/store/modules/auth/getters.js';
import { CANT_DELETE_APP_ERRORS, CANT_DELETE_APP_LOCATIONS } from '@/views/AppLayout/ManageAndCreate/create-and-manage.const.js';

export default {
	name: 'ManageAppsFavoriteAppsList',
	components: { ManageAppsFavoriteAppsListItem },
	computed: {
		...mapGettersShorthand({ allCalculatedDirectoryApps, allCalculatedDirectoryAppsIds, userRequestedApps }),
	},
	methods: {
		...mapActionsShorthand({ getAllDirectoryApps }),
		getToolTipText(item) {
			return item.cantDeleteReason ? `${item?.service_name} - ${CANT_DELETE_APP_ERRORS[item.cantDeleteReason]}` : item?.service_name;
		},
		getDescription(item) {
			return item.cantDeleteReason ? CANT_DELETE_APP_LOCATIONS[item.cantDeleteReason] : null;
		},
	},
	watch: {
		allCalculatedDirectoryAppsIds: {
			handler(specificIds) {
				if (specificIds?.length) {
					this.getAllDirectoryApps({ specificIds });
				}
			},
			immediate: true,
		},
	},
};
</script>

<style scoped lang="scss"></style>
